type QueryValue = string | number | boolean | null | undefined | string[]

interface BuildQueryParams {
  [key: string]: QueryValue
}

export const buildQueryParams = (
  params: BuildQueryParams = {},
): URLSearchParams => {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return
    }

    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item) {
          searchParams.append(key, item)
        }
      })

      return
    }

    searchParams.append(key, String(value))
  })

  return searchParams
}
